<template>
  <div class='ProductList'>
    <div class="img" @click="Select">
      <img v-if="data.img.length" :src="api + data.img[0].img">
      <div class="icon-img" v-if="!data.img.length">
        <img-icon :options="{ width: '55px', height: '45px', color: '#CCCCCC', action: true }"/>
      </div>
    </div>
    <div class="text">{{ data.name.length > 35 ? data.name.substr(0, 34) + '...' : data.name }}</div>
    <div class="preco">
      {{ data.oferta > 0 ? data.oferta.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) : data.preco.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ImgIcon from '../EnbPainel/Icons/ImgIcon'
import api from '@/mixins/api'
export default {
  name: 'ProductList',
  props: ['data'],
  components: { ImgIcon },
  mixins: [api],
  methods: {
    ...mapActions(['SetItem01']),
    Select () {
      this.SetItem01(this.data)
        .then(async () => {
          this.$router.push(`/${this.data.link}`)
        })
    }
  }
}
</script>

<style scoped>
.ProductList {
  /* flex: 1 1 calc(20%); */
  width: 180px;
  height: 280px;
  margin: 1%;
  background-color: #FFFFFF;
  border-radius: 7px;
  overflow: hidden;
}

.img {
  width: 100%;
  height: 70%;
  overflow: hidden;
}

.icon-img {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

img {
  width: 100%;
  height: 100%;
  animation: startOff 0.2s forwards;
  cursor: pointer;
}

img:hover {
  animation: startOn 0.2s forwards;
}

.text {
  width: 90%;
  height: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 16px;
  padding: 5%;
}

.preco {
  width: 100%;
  height: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
}

@keyframes startOn {
  0% {
    width: 100%;
    height: 100%;
  }
  100% {
    width: 110%;
    height: 110%;
    margin-left: -5%;
    margin-top: -5%;
  }
}
@keyframes startOff {
  0% {
    width: 110%;
    height: 110%;
    margin-left: -5%;
    margin-top: -5%;
  }
  100% {
    width: 100%;
    height: 100%;
    margin-left: 0%;
    margin-top: 0%;
  }
}

@media (max-width: 500px) {
  .ProductList {
    margin: 2%;
  }
}
</style>
